<div class="container">
  <div class="row">
    <div class="pageTitle">{{ 'home.title' | translate }}</div>
  </div>
  @if (shouldDisplayPremiumOffer) {
    <div class="row">
      <offer-banner></offer-banner>
    </div>
  }
  <div class="row row-gap-3">
    <div class="col-12 col-md-6 col-lg-4 cardContainer">
      <div class="card blue">
        @if (user?.is_parent ?? false) {
          <div class="title">
            {{ 'home.cards.childCourse.titleParent' | translate }}
          </div>
        } @else {
          <div class="title">
            {{ 'home.cards.childCourse.titleTeacher' | translate }}
          </div>
        }
        @if (user?.is_parent ?? false) {
          <div class="subtitle">
            {{ 'home.cards.childCourse.subtitleParent' | translate }}
          </div>
        } @else {
          <div class="subtitle">
            {{ 'home.cards.childCourse.subtitleTeacher' | translate }}
          </div>
        }
        <div class="discoverBtn ctaBtn zoomPlusHalo" (click)="navigateToChildHome()">
          {{ 'home.cards.childCourse.button' | translate }}
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-4 cardContainer">
      <div class="card pink">
        @if (user?.is_parent ?? false) {
          <div class="title">
            {{ 'home.cards.parentCourse.titleParent' | translate }}
          </div>
        } @else {
          <div class="title">
            {{ 'home.cards.parentCourse.titleTeacher' | translate }}
          </div>
        }
        <div class="subtitle">
          {{ 'home.cards.parentCourse.subtitle' | translate }}
        </div>
        <div class="discoverBtn ctaBtn zoomPlusHalo" (click)="navigateToParcoursTP()">
          {{ 'home.cards.parentCourse.button' | translate }}
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-4 cardContainer">
      <div class="card yellow">
        @if (user?.is_parent ?? false) {
          <div class="title">
            {{ 'home.cards.followUp.titleParent' | translate }}
          </div>
        } @else {
          <div class="title">
            {{ 'home.cards.followUp.titleTeacher' | translate }}
          </div>
        }
        @if (user?.is_parent ?? false) {
          <div class="subtitle">
            {{ 'home.cards.followUp.subtitleParent' | translate }}
          </div>
        } @else {
          <div class="subtitle">
            {{ 'home.cards.followUp.subtitleTeacher' | translate }}
          </div>
        }
        <div class="discoverBtn ctaBtn zoomPlusHalo" (click)="navigateToFollowUp()">
          {{ 'home.cards.followUp.button' | translate }}
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-4 cardContainer">
      <div class="card orange">
        <div class="title">
          {{ 'home.cards.teachingSheets.title' | translate }}
        </div>
        <div class="subtitle">
          {{ 'home.cards.teachingSheets.subtitle' | translate }}
        </div>
        <div class="discoverBtn ctaBtn zoomPlusHalo" (click)="navigateToTeachingSheets()">
          {{ 'home.cards.teachingSheets.button' | translate }}
        </div>
      </div>
    </div>

    @if (!isGarUser) {
      <div class="col-12 col-md-6 col-lg-4 cardContainer">
        <div class="card purple">
          <div class="title">
            {{ 'home.cards.help.title' | translate }}
          </div>
          <div class="subtitle">
            {{ 'home.cards.help.subtitle' | translate }}
          </div>
          <div class="discoverBtn ctaBtn zoomPlusHalo" (click)="navigateToHelp()">
            {{ 'home.cards.help.button' | translate }}
          </div>
        </div>
      </div>
    }
  </div>
</div>
